import React from 'react';
import '../common/btn1.css';

const Btn1 = (props) => {
    return (
        <>
            <button className={props.b}>
                <span>{props.btntt}</span>
                <img className='btn1ic' src={props.ic} alt="" />
            </button>
        </>
    );
};

export default Btn1;